module.exports = __webpack_public_path__ + "img/76_27.3720a745.png";